

(function () {
    'use strict';

    function byId(id) { return document.getElementById(id); }

    function copyFromContact() {
        var pairs = [
            ['requestorFirstName', 'endCustomerFirstName'],
            ['requestorLastName', 'endCustomerLastName'],
            ['requestorCompanyName', 'endCustomerCompanyName'],
            ['requestorAddress1', 'endCustomerAddress1'],
            ['requestorAddress2', 'endCustomerAddress2'],
            ['requestorCity', 'endCustomerCity'],
            ['requestorState', 'endCustomerState'],
            ['requestorPostalCode', 'endCustomerPostalCode'],
            ['requestorCountry', 'endCustomerCountry'],
            ['requestorEmail', 'endCustomerEmail'],
            ['requestorPhone', 'endCustomerPhone'],
            ['requestorCompanyUrl', 'endCustomerCompanyUrl'],
            ['requestorJobTitle', 'endCustomerJobTitle']
        ];

        for (var i = 0; i < pairs.length; i++) {
            var fromEl = byId(pairs[i][0]);
            var toEl = byId(pairs[i][1]);
            if (fromEl && toEl) {
                toEl.value = fromEl.value;
            }
        }

        var btn = byId('sameAsContactBtn');
        if (btn && btn.blur) { btn.blur(); }
    }

    function setMinDate() {
        var el = byId('requestedDeliveryDate');
        if (!el) { return; }
        var today = new Date().toISOString().split('T')[0];
        el.setAttribute('min', today);
    }

    function sanitizeTelInputs() {
        var inputs = document.querySelectorAll('#request-form input[type="tel"]');
        Array.prototype.forEach.call(inputs, function (input) {
            input.addEventListener('input', function () {
                this.value = this.value.replace(/[^0-9+\-\s()]/g, '');
            });
        });
    }

    function clampQuantity() {
        var qty = byId('quantity');
        if (!qty) { return; }
        qty.addEventListener('input', function () {
            var v = parseInt(this.value, 10);
            if (isNaN(v)) { return; }
            else if (v < 1) { this.value = 1; }
        });
    }

    function showWelcomeEmail() {
        var emailField = byId('requestorEmail');
        var welcomeUser = byId('user-name');
        if (emailField && welcomeUser && emailField.value) {
            welcomeUser.textContent = emailField.value;
        }
    }

    function init() {
        var copyBtn = byId('sameAsContactBtn');
        if (copyBtn) {
            copyBtn.addEventListener('click', copyFromContact);
        }
        setMinDate();
        sanitizeTelInputs();
        clampQuantity();
        showWelcomeEmail();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
